import { render, staticRenderFns } from "./Authorized.vue?vue&type=template&id=12a4d080&"
import script from "./Authorized.vue?vue&type=script&lang=js&"
export * from "./Authorized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports